<script>
import cloneDeep from 'lodash/cloneDeep'
import { memberDetailsComputed } from '@state/helpers/member-details'
import qa from './qa'

export default {
  props: {
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      questionlist: cloneDeep(qa),
    }
  },
  computed: {
    ...memberDetailsComputed,
    questionComputed() {
      if (this.getDetails?.agent_list[0]) {
        const list = cloneDeep(this.getDetails?.agent_list[0])
        return this.questionlist?.map((item) => {
          item.question = list[item.keyQ]
          item.answer = list[item.keyA]
          return item
        })
      }
      return this.questionlist
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail form-collapsed :trigger-mask="triggerMask" title="回答">
      <template v-slot:header-action>
        <div class="my-3"></div>
      </template>

      <div v-for="(item, index) in questionComputed" :key="index">
        <template v-if="item.question !== ''">
          <div
            v-if="item.question || item.answer"
            class="border border-bottom-0 border-left-0 border-right-0 py-2 mx-1 d-flex align-items-center"
          >
            <div class="col-sm-5"> {{ item.question }}</div>
            <div class="col-sm-7 feeline-color-content"> {{ item.answer }}</div>
          </div>
        </template>
      </div>
    </BaseCardDetail>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feeline-color-content {
  color: $gray-900;
}
</style>
